import { Menu } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledMenuMooh = styled(Menu)`
min-width: 18rem;
margin: 0 !important;
background: #dadada !important;
border-radius: 1.3em !important;
height: 100%;
overflow-y: auto;
min-height: calc(100vh - 120px);
::-webkit-scrollbar {
  width: 6px;
  background-color: #3399FF;
  border-radius: 3px;
  top: 15px;
  color: #1A3175;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3) !important;
  background-color: #D6D6D6 !important;
}
 .itemWrapper {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
 }

 .dropdownDivider {
 }

 .titleWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
 > div {
   cursor: pointer;
 }
 > a.item {
   color: #6F6A6E !important;
   &:hover {
      background-color: #D09295 !important;
      color: #ffff !important;
    }
    &.active {
      background-color: #D09295 !important;
     color: #ffff !important;
    }
 }
 .menu {
   margin: auto !important;
   margin-top: 10px !important;
   .item {
    padding-left: 0.9em !important;
    color: #6F6A6E !important;
   }
    a.item {
    color: #6F6A6E !important;
    &:hover {
      background-color: #D09295 !important;
     color: #ffff !important;
    }
    padding: 0.92857143em 0.9em !important;
    &.active {
      background-color: #D09295 !important;
      color: #ffff !important;
    }
   }
 }
`
export const StyledMenu = styled(Menu)`
min-width: 18rem;
color: white;
margin-top: 17px !important;
background: none !important;
overflow-y: auto; 
::-webkit-scrollbar {
  width: 6px;
  background-color: #3399FF;
  border-radius: 3px;
  top: 15px;
  color: #1A3175;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3) !important;
  background-color: #D6D6D6 !important;
}
 .itemWrapper {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
   color: white;
 }

 .dropdownDivider {  
 }

 .titleWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
}
 > div {
   cursor: pointer;
 }
 > a.item {
   &:hover {
      background-color: #304993 !important;
      color: #ffffff !important;
    }
   color: white !important;
    &.active {
      background-color: #304993 !important;
      color: white !important;
    }
 }
 .menu {
   margin: auto !important;
   margin-top: 10px !important;
   .item {
    padding-left: 0.9em !important;
   }
    a.item {    
    &:hover {
      background-color: #304993 !important;
      color: #ffffff !important;
    }
    padding: 0.92857143em 0.9em !important;
    color: white !important;
    &.active {      
      background-color: #304993 !important;
      color: white !important;
    }
   }
 } 
`
